import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // 16px text so iOS Safari never zooms on focus.
        "flex h-11 w-full rounded-md border border-line-strong bg-surface px-3 text-base text-ink transition-colors file:border-0 file:bg-transparent file:text-sm file:font-bold file:text-ink placeholder:text-ink-muted aria-[invalid=true]:border-2 aria-[invalid=true]:border-sev-high disabled:cursor-not-allowed disabled:bg-sunken disabled:text-ink-muted",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
